<template>
  <div class="courier-form">
    <h2>{{ isEdit ? 'Edit Courier' : 'Add New Courier' }}</h2>

    <form @submit.prevent="saveCourier">
      <table class="form-table">
        <tbody>
        <tr>
          <th><label for="courier_name">Courier Name</label></th>
          <td>
            <input
              type="text"
              id="courier_name"
              v-model="form.courier_name"
              required
            />
          </td>
        </tr>
        <tr>
          <th><label for="api_endpoint">API Endpoint</label></th>
          <td>
            <input
              type="url"
              id="api_endpoint"
              v-model="form.api_endpoint"
              required
            />
          </td>
        </tr>
        <tr>
          <th><label for="api_key">API Key</label></th>
          <td>
            <input
              type="text"
              id="api_key"
              v-model="form.api_key"
              required
            />
          </td>
        </tr>
        <tr>
          <th><label for="tracking_url">Tracking URL</label></th>
          <td>
            <input
              type="url"
              id="tracking_url"
              v-model="form.tracking_url"
              required
            />
            <p class="description">
              Use {tracking_number} as placeholder for the tracking number
            </p>
          </td>
        </tr>
        <tr>
          <th><label for="status">Status</label></th>
          <td>
            <select id="status" v-model="form.status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </td>
        </tr>
      </tbody>
      </table>

      <div class="button-group">
        <button type="submit" class="button button-primary">
          {{ isEdit ? 'Update Courier' : 'Add Courier' }}
        </button>
        <router-link to="/couriers" class="button">
          Cancel
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: 'CourierForm',
  
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const form = ref({
      courier_name: '',
      api_endpoint: '',
      api_key: '',
      tracking_url: '',
      status: 'active'
    });

    const isEdit = computed(() => !!route.params.id);

    onMounted(async () => {
      if (isEdit.value) {
        try {
          const response = await fetch(
            `${RestaurantMenuMangeData.apiUrl}/couriers/${route.params.id}`,
            {
              headers: {
                'easyRestaurantManager-nonce': RestaurantMenuMangeData.nonce
              }
            }
          );
          const data = await response.json();
          if (data.success) {
            form.value = { ...data.data };
          }
        } catch (error) {
          console.error('Error fetching courier:', error);
        }
      }
    });

    const saveCourier = async () => {
      try {
        const url = isEdit.value
          ? `${RestaurantMenuMangeData.apiUrl}/couriers/${route.params.id}`
          : `${RestaurantMenuMangeData.apiUrl}/couriers`;

        const response = await fetch(url, {
          method: isEdit.value ? 'PUT' : 'POST',
          headers: {
            'Content-Type': 'application/json',
            'easyRestaurantManager-nonce': RestaurantMenuMangeData.nonce
          },
          body: JSON.stringify(form.value)
        });

        const data = await response.json();
        if (data.success) {
          if (isEdit.value) {
            store.commit('updateCourier', data.data);
          } else {
            store.commit('addCourier', data.data);
          }
          router.push('/couriers');
        }
      } catch (error) {
        console.error('Error saving courier:', error);
      }
    };

    return {
      form,
      isEdit,
      saveCourier
    };
  }
};
</script>

<!-- <style lang="scss" scoped>
.courier-form {
  max-width: 800px;
  
  .description {
    color: #666;
    font-style: italic;
    margin: 5px 0 0;
  }
}
</style> -->
